import React, { useEffect, useState, useCallback, memo } from 'react';
import Tippy from '@tippyjs/react';
import { ReactComponent as TimerIcon } from 'assets/icons/sands-of-time.svg';
import { OrderType } from 'models/order.model';

type Props = {
  order: OrderType;
};
const OrderTime = ({ order }: Props) => {
  const [orderTimer, setOrderTimer] = useState(false);
  const [displayTime, setDisplayTime] = useState('00:00:00');
  const [color, setColor] = useState('#bbf7d0');

  function formatTime(ms: number) {
    const totalSeconds = Math.floor(ms / 1000);
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(
      secs
    ).padStart(2, '0')}`;
  }

  const updateTimer = useCallback(() => {
    if (!order.kitchen_verified_time) return;

    setOrderTimer(true);
    const startTs = new Date(order.kitchen_verified_time).getTime();
    const now = Date.now();
    const elapsed = now - startTs;

    setDisplayTime(formatTime(elapsed));

    const minutes = Math.floor(elapsed / 60000);
    if (minutes < 15) {
      setColor('#FDEDBE');
    } else if (minutes < 30) {
      setColor('#CBEEC3');
    } else if (minutes < 50) {
      setColor('#FCB6C0');
    } else {
      setColor('#FEE2E2');
    }
  }, [order.kitchen_verified_time]);

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    if (order.completed || order.cancelled || !order.paid) {
      return;
    }

    updateTimer();
    intervalId = setInterval(updateTimer, 1000);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [order.completed, order.cancelled, order.paid]);

  if (!orderTimer) return null;
  return (
    <Tippy
      content={
        <div className=' p-2 px-3 rounded-md shadow-md bg-white text-gray-8 font-medium text-xs'>
          Total order time
        </div>
      }>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '0.5rem',
          gap: '0.25rem',
          backgroundColor: color,
          padding: '4px'
        }}>
        <TimerIcon className='w-3 h-3' />
        <p className='text-[11px] font-semibold'>{displayTime}</p>
      </div>
    </Tippy>
  );
};

export default memo(OrderTime);
